import {types} from './types';
import ReadDocument from "./ReadDocument/ReadDocument";
import AddHeader from "./AddHeader/AddHeader";
import AddParagraph from "./AddParagraph/AddParagraph";
import AddImage from "./AddImage/AddImage";
import Save from "./Save/Save";

/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @param       setOpenVariable - open variable function that allows us to open
 * @param       showAlert -  show alert
 * @returns     JSX.Element
 * @author      ibrahim AKIN
 */
function Actions(action, showAlert, variables, setOpenVariable) {
    switch (action.actionName) {
        case types.READDOCUMENT:
            return <ReadDocument action={action} showAlert={showAlert} variables={variables}
                                 setOpenVariable={setOpenVariable}/>;
        case types.ADDHEADER:
            return <AddHeader action={action} showAlert={showAlert} variables={variables}
                              setOpenVariable={setOpenVariable}/>;
        case types.ADDPARAGRAPH:
            return <AddParagraph action={action} showAlert={showAlert} variables={variables}
                                 setOpenVariable={setOpenVariable}/>;
        case types.ADDIMAGE:
            return <AddImage action={action} showAlert={showAlert} variables={variables}
                             setOpenVariable={setOpenVariable}/>;
        case types.SAVE:
            return <Save action={action} showAlert={showAlert} variables={variables}
                         setOpenVariable={setOpenVariable}/>;
        default:
            break;
    }
}

export default Actions;
